/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  PoolService,
  Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto,
} from '../../services/wealthlane-award-services';

const usePostSharePool = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal?: any,
  id?: string
): UseMutationResult<Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto | undefined, unknown, any> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(PoolService.putApiAwardApiAppPoolPool(payload));
      } else {
        return await handleRequest(PoolService.postApiAwardApiAppPoolPool(payload));
      }
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          await queryClient.invalidateQueries('getSharePoolList');
          closeModal();
          toast.success(
            <ToastComponent label='Success' message={`Share Pool ${id ? 'Edited' : 'Added'} `} />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSharePool;
